import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout';
import { useFetchVideoGallery } from '../hooks/useAppInit';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/SingleVideoGallery.css';

export default function SingleVideoGallery() {
  useFetchVideoGallery();
  const { videoId } = useParams();
  const videos = useSelector((state) => state.videoGallery.videos);
  const video = videos.find((v) => v._id === videoId);

  const title = video?.title || 'School Video';
  const videoUrl = video?.videoUrl || 'https://www.youtube.com/embed/dQw4w9WgXcQ';

  return (
    <Layout bannerTitle={title}>
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <LineSeperator title={title} />
            <Link to="/videoall" className="back-btn">
              <i className="fas fa-arrow-left me-1"></i> Back to Videos
            </Link>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="video-embed-wrapper">
                <iframe
                  src={videoUrl}
                  title={title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="video-embed"
                ></iframe>
              </div>
              <div className="video-detail-info mt-4">
                <h4>{title}</h4>
                {video?.description && <p>{video.description}</p>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
